"use client";

import React from "react";
import { LocaleLink as Link } from "@/components/shared/LocaleLink";
import { useTranslations } from "@/lib/i18n-client";
import { Reveal } from "@/components/shared/motion";
import { Plane, ArrowRight } from "lucide-react";

/**
 * WanderLite final CTA — a soft blue rounded band with a gentle dotted flight
 * path motif and a white rounded-full pill to the shared /destinations/ page.
 * Solid pastel-friendly blue, no gradient blobs.
 */
export default function FinalCta() {
  const { t } = useTranslations();

  return (
    <section className="container mx-auto px-4 py-14">
      <Reveal as="div" className="relative overflow-hidden rounded-3xl bg-primary p-10 text-center text-white sm:p-14" y={22}>
        <div className="mb-5 flex items-center justify-center gap-2 text-white/70" aria-hidden="true">
          <Plane className="h-5 w-5 -rotate-12" />
          <span className="wander-dash w-28 opacity-70" />
        </div>
        <h2 className="text-2xl font-extrabold sm:text-4xl">
          {t("wander.finalCta.title", "Ready for your next adventure?")}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-white/85">
          {t("wander.finalCta.subtitle", "Pick a destination and get your eSIM by email — set up in minutes.")}
        </p>
        <Link
          href="/destinations/"
          className="mt-7 inline-flex items-center gap-2 rounded-full bg-white px-7 py-3 font-bold text-primary shadow-sm transition-all active:scale-[0.98] hover:bg-white/90"
        >
          {t("wander.finalCta.cta", "Find my destination")}
          <ArrowRight className="h-4 w-4" />
        </Link>
      </Reveal>
    </section>
  );
}
